import CheckIcon from '@mui/icons-material/Check'
import { Button } from '@mui/material'
import React from 'react'

interface DateQuickButtonProps {
  label?: string
  onClick: () => void
  disabled?: boolean
  active?: boolean
  icon?: React.ReactNode
}

const DateQuickButton: React.FC<DateQuickButtonProps> = ({
  label,
  onClick,
  disabled = false,
  active = false,
  icon,
}) => {
  return (
    <Button
      type="button"
      disabled={disabled}
      onClick={onClick}
      onMouseDown={(e) => e.preventDefault()}
      variant={active ? 'contained' : 'outlined'}
      size="small"
      disableRipple
      disableFocusRipple
      disableTouchRipple
      startIcon={
        active ? <CheckIcon sx={{ fontSize: '12px !important' }} /> : icon
      }
      sx={(theme) => ({
        fontSize: '11px',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.3px',
        borderRadius: 999,
        px: label ? 1.25 : 0.5,
        py: 0.125,
        lineHeight: 1.4,
        minHeight: 0,
        minWidth: 0,
        '& .MuiButton-startIcon': {
          marginRight: label ? '4px' : 0,
          marginLeft: label ? '-2px' : 0,
        },
        border: `1px solid ${theme.palette.divider}`,
        '&:hover': {
          border: `1px solid ${theme.palette.divider}`,
        },
        ...(active
          ? {
              backgroundColor: theme.palette.brand.dark,
              color: theme.palette.common.white,
              borderColor: `${theme.palette.brand.dark} !important`,
              boxShadow: 'none',
              '&:hover, &:focus, &:active, &.Mui-focusVisible': {
                backgroundColor: theme.palette.brand.dark,
                border: `1px solid ${theme.palette.brand.dark}`,
                boxShadow: 'none',
              },
            }
          : {
              backgroundColor: theme.palette.background.default,
              color: theme.palette.brand.dark,
              '&:hover': {
                backgroundColor: theme.palette.action.hover,
                border: `1px solid ${theme.palette.brand.dark}`,
              },
            }),
      })}
    >
      {label}
    </Button>
  )
}

export default DateQuickButton
